import React, { useEffect, useState } from 'react';
import { translate } from '../../services/translate';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { StyleProp, TextStyle } from 'react-native';
import { crmService } from '../../services/central-api/crm';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    onSelect?: (value: { id: number; name: string; }) => void;
}

export default function CrmCompaniesDropdown({ value, setValue, zIndex, labelStyle, viewStyle, onSelect }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [companiesSimplified, setCompaniesSimplified] = useState<{ id: number; name: string; }[]>();

    async function getCompaniesSimplified() {
        try {
            const companies = await crmService.getCompaniesSimplified();

            setCompaniesSimplified(companies);

            setItems(companies.map((company) => ({
                value: company.id,
                label: company.name
            })));

            if (value === 0 && companies.length === 1) {
                setValue(companies[0].id);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getCompaniesSimplified();
    }, []);

    useEffect(() => {
        if (value && onSelect && companiesSimplified) {
            const company = companiesSimplified.find(c => c.id === value);
            if (company) {
                onSelect(company);
            }
        }
    }, [value, companiesSimplified]);

    return (
        <FilterDropdown
            placeholder={translate('company')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
